import React from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const BulkActionsBar = ({ selectedCount, onBulkAction, onClearSelection }) => {
  return (
    <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div className="flex items-center gap-3">
          <Icon name="CheckSquare" size={20} color="var(--color-primary)" />
          <span className="font-medium text-gray-900">
            {selectedCount} employee{selectedCount !== 1 ? "s" : ""} selected
          </span>
        </div>

        <div className="flex items-center gap-2 flex-wrap">
          <Button
            variant="outline"
            size="sm"
            iconName="CheckCircle"
            onClick={() => onBulkAction("make-eligible")}
            title="Mark selected employees as eligible for TRONC"
          >
            Make Eligible
          </Button>

          <Button
            variant="outline"
            size="sm"
            iconName="XCircle"
            onClick={() => onBulkAction("make-ineligible")}
            title="Mark selected employees as ineligible for TRONC"
          >
            Make Ineligible
          </Button>

          <Button
            variant="outline"
            size="sm"
            iconName="Download"
            onClick={() => onBulkAction("export")}
            title="Export selected employees to CSV"
          >
            Export Selected
          </Button>

          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            onClick={onClearSelection}
            title="Clear selection"
          >
            Clear
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;
